var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:writing-hand-medium-light",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_i_1591_14301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.59274 8.65736C6.0982 7.84567 6.89464 7.25773 7.8192 7.01376C8.74377 6.7698 9.7266 6.88824 10.5667 7.34486L12.7267 8.51861L9.49724 13.8286L8.43674 11.1736L5.19899 16.8129C5.07379 17.0314 4.9064 17.2229 4.70655 17.3763C4.50671 17.5296 4.27839 17.6417 4.03485 17.706C3.79132 17.7704 3.53743 17.7857 3.28793 17.751C3.03844 17.7164 2.7983 17.6326 2.58149 17.5044L2.49449 17.4526C2.27813 17.3248 2.08926 17.1553 1.93879 16.9541C1.78833 16.7528 1.67925 16.5237 1.61788 16.28C1.5565 16.0363 1.54405 15.7829 1.58123 15.5344C1.61841 15.2859 1.70449 15.0472 1.83449 14.8321L4.54949 10.3426L4.54574 10.3396L4.75574 10.0014L5.19374 9.27836C5.32124 9.06611 5.44724 8.86136 5.59274 8.65736Z",
    fill: "url(#paint0_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.59274 8.65736C6.0982 7.84567 6.89464 7.25773 7.8192 7.01376C8.74377 6.7698 9.7266 6.88824 10.5667 7.34486L12.7267 8.51861L9.49724 13.8286L8.43674 11.1736L5.19899 16.8129C5.07379 17.0314 4.9064 17.2229 4.70655 17.3763C4.50671 17.5296 4.27839 17.6417 4.03485 17.706C3.79132 17.7704 3.53743 17.7857 3.28793 17.751C3.03844 17.7164 2.7983 17.6326 2.58149 17.5044L2.49449 17.4526C2.27813 17.3248 2.08926 17.1553 1.93879 16.9541C1.78833 16.7528 1.67925 16.5237 1.61788 16.28C1.5565 16.0363 1.54405 15.7829 1.58123 15.5344C1.61841 15.2859 1.70449 15.0472 1.83449 14.8321L4.54949 10.3426L4.54574 10.3396L4.75574 10.0014L5.19374 9.27836C5.32124 9.06611 5.44724 8.86136 5.59274 8.65736Z",
    fill: "url(#paint1_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.59274 8.65736C6.0982 7.84567 6.89464 7.25773 7.8192 7.01376C8.74377 6.7698 9.7266 6.88824 10.5667 7.34486L12.7267 8.51861L9.49724 13.8286L8.43674 11.1736L5.19899 16.8129C5.07379 17.0314 4.9064 17.2229 4.70655 17.3763C4.50671 17.5296 4.27839 17.6417 4.03485 17.706C3.79132 17.7704 3.53743 17.7857 3.28793 17.751C3.03844 17.7164 2.7983 17.6326 2.58149 17.5044L2.49449 17.4526C2.27813 17.3248 2.08926 17.1553 1.93879 16.9541C1.78833 16.7528 1.67925 16.5237 1.61788 16.28C1.5565 16.0363 1.54405 15.7829 1.58123 15.5344C1.61841 15.2859 1.70449 15.0472 1.83449 14.8321L4.54949 10.3426L4.54574 10.3396L4.75574 10.0014L5.19374 9.27836C5.32124 9.06611 5.44724 8.86136 5.59274 8.65736Z",
    fill: "url(#paint2_linear_1591_14301)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.3797 20.5511L10.8765 19.2581L11.8905 17.7686H22.413V21.2028C22.413 21.6006 22.2549 21.9822 21.9736 22.2635C21.6923 22.5448 21.3108 22.7028 20.913 22.7028H14.5252C13.8452 22.7028 13.181 22.4974 12.6197 22.1134C12.0584 21.7294 11.6262 21.1849 11.3797 20.5511Z",
    fill: "url(#paint3_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.3797 20.5511L10.8765 19.2581L11.8905 17.7686H22.413V21.2028C22.413 21.6006 22.2549 21.9822 21.9736 22.2635C21.6923 22.5448 21.3108 22.7028 20.913 22.7028H14.5252C13.8452 22.7028 13.181 22.4974 12.6197 22.1134C12.0584 21.7294 11.6262 21.1849 11.3797 20.5511Z",
    fill: "url(#paint4_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.3797 20.5511L10.8765 19.2581L11.8905 17.7686H22.413V21.2028C22.413 21.6006 22.2549 21.9822 21.9736 22.2635C21.6923 22.5448 21.3108 22.7028 20.913 22.7028H14.5252C13.8452 22.7028 13.181 22.4974 12.6197 22.1134C12.0584 21.7294 11.6262 21.1849 11.3797 20.5511Z",
    fill: "url(#paint5_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.0737 19.1958C11.0737 18.195 10.2624 17.3838 9.26171 17.3838C8.26097 17.3838 7.44971 18.195 7.44971 19.1958V20.8105C7.44971 21.8113 8.26097 22.6225 9.26171 22.6225C10.2624 22.6225 11.0737 21.8113 11.0737 20.8105V19.1958Z",
    fill: "url(#paint6_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.0737 19.1958C11.0737 18.195 10.2624 17.3838 9.26171 17.3838C8.26097 17.3838 7.44971 18.195 7.44971 19.1958V20.8105C7.44971 21.8113 8.26097 22.6225 9.26171 22.6225C10.2624 22.6225 11.0737 21.8113 11.0737 20.8105V19.1958Z",
    fill: "url(#paint7_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.0737 19.1958C11.0737 18.195 10.2624 17.3838 9.26171 17.3838C8.26097 17.3838 7.44971 18.195 7.44971 19.1958V20.8105C7.44971 21.8113 8.26097 22.6225 9.26171 22.6225C10.2624 22.6225 11.0737 21.8113 11.0737 20.8105V19.1958Z",
    fill: "url(#paint8_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.605 1.91396C13.6296 1.87115 13.6624 1.83362 13.7015 1.8035C13.7406 1.77338 13.7852 1.75128 13.8329 1.73846C13.8806 1.72564 13.9303 1.72235 13.9792 1.72879C14.0281 1.73522 14.0753 1.75125 14.118 1.77596L16.3403 3.05846C16.4261 3.10806 16.4889 3.18964 16.5147 3.28535C16.5406 3.38107 16.5275 3.48313 16.4783 3.56921L6.32254 21.3045C6.2857 21.3688 6.23063 21.4207 6.16429 21.4537L3.78229 22.635C3.66079 22.695 3.55879 22.635 3.55279 22.5L3.38329 19.8442C3.37967 19.7727 3.39658 19.7017 3.43204 19.6395L13.605 1.91396Z",
    fill: "url(#paint9_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.605 1.91396C13.6296 1.87115 13.6624 1.83362 13.7015 1.8035C13.7406 1.77338 13.7852 1.75128 13.8329 1.73846C13.8806 1.72564 13.9303 1.72235 13.9792 1.72879C14.0281 1.73522 14.0753 1.75125 14.118 1.77596L16.3403 3.05846C16.4261 3.10806 16.4889 3.18964 16.5147 3.28535C16.5406 3.38107 16.5275 3.48313 16.4783 3.56921L6.32254 21.3045C6.2857 21.3688 6.23063 21.4207 6.16429 21.4537L3.78229 22.635C3.66079 22.695 3.55879 22.635 3.55279 22.5L3.38329 19.8442C3.37967 19.7727 3.39658 19.7017 3.43204 19.6395L13.605 1.91396Z",
    fill: "url(#paint10_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_f_1591_14301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9308 6.50098L6.14258 18.4537L12.9308 6.50098Z",
    fill: "url(#paint11_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9308 6.50098L6.14258 18.4537",
    stroke: "url(#paint12_linear_1591_14301)",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_i_1591_14301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M7.44967 16.7366C6.51142 17.3928 6.20992 18.7121 6.82117 19.6796C7.44817 20.6703 8.82667 20.9613 9.82492 20.3471L12.4724 18.7166C12.5498 18.669 12.6359 18.6373 12.7257 18.6233C12.8154 18.6094 12.9071 18.6134 12.9953 18.6353C13.0835 18.6571 13.1664 18.6963 13.2393 18.7506C13.3121 18.8049 13.3735 18.8731 13.4197 18.9513C13.919 19.7953 14.6499 20.4785 15.5256 20.92C16.4013 21.3614 17.3852 21.5426 18.3607 21.4421L21.2347 21.1466C21.5577 21.1132 21.8569 20.9612 22.0744 20.72C22.2919 20.4788 22.4122 20.1656 22.4122 19.8408V14.4933C22.4104 14.0778 22.2859 13.6721 22.0543 13.3271C21.8226 12.9822 21.4942 12.7134 21.1102 12.5546C19.4399 11.8586 16.3987 10.5378 13.3889 8.96582L9.83317 15.1758L7.44967 16.7366Z",
    fill: "url(#paint13_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M7.44967 16.7366C6.51142 17.3928 6.20992 18.7121 6.82117 19.6796C7.44817 20.6703 8.82667 20.9613 9.82492 20.3471L12.4724 18.7166C12.5498 18.669 12.6359 18.6373 12.7257 18.6233C12.8154 18.6094 12.9071 18.6134 12.9953 18.6353C13.0835 18.6571 13.1664 18.6963 13.2393 18.7506C13.3121 18.8049 13.3735 18.8731 13.4197 18.9513C13.919 19.7953 14.6499 20.4785 15.5256 20.92C16.4013 21.3614 17.3852 21.5426 18.3607 21.4421L21.2347 21.1466C21.5577 21.1132 21.8569 20.9612 22.0744 20.72C22.2919 20.4788 22.4122 20.1656 22.4122 19.8408V14.4933C22.4104 14.0778 22.2859 13.6721 22.0543 13.3271C21.8226 12.9822 21.4942 12.7134 21.1102 12.5546C19.4399 11.8586 16.3987 10.5378 13.3889 8.96582L9.83317 15.1758L7.44967 16.7366Z",
    fill: "url(#paint14_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M7.44967 16.7366C6.51142 17.3928 6.20992 18.7121 6.82117 19.6796C7.44817 20.6703 8.82667 20.9613 9.82492 20.3471L12.4724 18.7166C12.5498 18.669 12.6359 18.6373 12.7257 18.6233C12.8154 18.6094 12.9071 18.6134 12.9953 18.6353C13.0835 18.6571 13.1664 18.6963 13.2393 18.7506C13.3121 18.8049 13.3735 18.8731 13.4197 18.9513C13.919 19.7953 14.6499 20.4785 15.5256 20.92C16.4013 21.3614 17.3852 21.5426 18.3607 21.4421L21.2347 21.1466C21.5577 21.1132 21.8569 20.9612 22.0744 20.72C22.2919 20.4788 22.4122 20.1656 22.4122 19.8408V14.4933C22.4104 14.0778 22.2859 13.6721 22.0543 13.3271C21.8226 12.9822 21.4942 12.7134 21.1102 12.5546C19.4399 11.8586 16.3987 10.5378 13.3889 8.96582L9.83317 15.1758L7.44967 16.7366Z",
    fill: "url(#paint15_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M7.44967 16.7366C6.51142 17.3928 6.20992 18.7121 6.82117 19.6796C7.44817 20.6703 8.82667 20.9613 9.82492 20.3471L12.4724 18.7166C12.5498 18.669 12.6359 18.6373 12.7257 18.6233C12.8154 18.6094 12.9071 18.6134 12.9953 18.6353C13.0835 18.6571 13.1664 18.6963 13.2393 18.7506C13.3121 18.8049 13.3735 18.8731 13.4197 18.9513C13.919 19.7953 14.6499 20.4785 15.5256 20.92C16.4013 21.3614 17.3852 21.5426 18.3607 21.4421L21.2347 21.1466C21.5577 21.1132 21.8569 20.9612 22.0744 20.72C22.2919 20.4788 22.4122 20.1656 22.4122 19.8408V14.4933C22.4104 14.0778 22.2859 13.6721 22.0543 13.3271C21.8226 12.9822 21.4942 12.7134 21.1102 12.5546C19.4399 11.8586 16.3987 10.5378 13.3889 8.96582L9.83317 15.1758L7.44967 16.7366Z",
    fill: "url(#paint16_linear_1591_14301)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M7.44967 16.7366C6.51142 17.3928 6.20992 18.7121 6.82117 19.6796C7.44817 20.6703 8.82667 20.9613 9.82492 20.3471L12.4724 18.7166C12.5498 18.669 12.6359 18.6373 12.7257 18.6233C12.8154 18.6094 12.9071 18.6134 12.9953 18.6353C13.0835 18.6571 13.1664 18.6963 13.2393 18.7506C13.3121 18.8049 13.3735 18.8731 13.4197 18.9513C13.919 19.7953 14.6499 20.4785 15.5256 20.92C16.4013 21.3614 17.3852 21.5426 18.3607 21.4421L21.2347 21.1466C21.5577 21.1132 21.8569 20.9612 22.0744 20.72C22.2919 20.4788 22.4122 20.1656 22.4122 19.8408V14.4933C22.4104 14.0778 22.2859 13.6721 22.0543 13.3271C21.8226 12.9822 21.4942 12.7134 21.1102 12.5546C19.4399 11.8586 16.3987 10.5378 13.3889 8.96582L9.83317 15.1758L7.44967 16.7366Z",
    fill: "url(#paint17_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M7.44967 16.7366C6.51142 17.3928 6.20992 18.7121 6.82117 19.6796C7.44817 20.6703 8.82667 20.9613 9.82492 20.3471L12.4724 18.7166C12.5498 18.669 12.6359 18.6373 12.7257 18.6233C12.8154 18.6094 12.9071 18.6134 12.9953 18.6353C13.0835 18.6571 13.1664 18.6963 13.2393 18.7506C13.3121 18.8049 13.3735 18.8731 13.4197 18.9513C13.919 19.7953 14.6499 20.4785 15.5256 20.92C16.4013 21.3614 17.3852 21.5426 18.3607 21.4421L21.2347 21.1466C21.5577 21.1132 21.8569 20.9612 22.0744 20.72C22.2919 20.4788 22.4122 20.1656 22.4122 19.8408V14.4933C22.4104 14.0778 22.2859 13.6721 22.0543 13.3271C21.8226 12.9822 21.4942 12.7134 21.1102 12.5546C19.4399 11.8586 16.3987 10.5378 13.3889 8.96582L9.83317 15.1758L7.44967 16.7366Z",
    fill: "url(#paint18_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M12.6936 10.1797L9.83838 15.1672L11.1569 14.3392C11.9379 13.8485 12.8664 13.6476 13.7804 13.7714L15.6036 14.0189L12.6936 10.1797Z",
    fill: "url(#paint19_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12 4.71034L12.8047 3.30859L15.672 4.97734L14.8695 6.37984L12 4.71034Z",
    fill: "url(#paint20_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M12 4.71034L12.8047 3.30859L15.672 4.97734L14.8695 6.37984L12 4.71034Z",
    fill: "url(#paint21_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M6.28937 21.351C6.25531 21.3938 6.2123 21.4286 6.16337 21.453L3.78137 22.6343C3.65987 22.6943 3.55787 22.6343 3.55187 22.4993L3.38237 19.8435C3.38009 19.8008 3.38516 19.7579 3.39737 19.7168L6.28937 21.351Z",
    fill: "url(#paint22_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M6.28937 21.351C6.25531 21.3938 6.2123 21.4286 6.16337 21.453L3.78137 22.6343C3.65987 22.6943 3.55787 22.6343 3.55187 22.4993L3.38237 19.8435C3.38009 19.8008 3.38516 19.7579 3.39737 19.7168L6.28937 21.351Z",
    fill: "url(#paint23_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M6.28937 21.351C6.25531 21.3938 6.2123 21.4286 6.16337 21.453L3.78137 22.6343C3.65987 22.6943 3.55787 22.6343 3.55187 22.4993L3.38237 19.8435C3.38009 19.8008 3.38516 19.7579 3.39737 19.7168L6.28937 21.351Z",
    fill: "url(#paint24_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M4.3943 22.3301L3.78154 22.6338C3.66004 22.6938 3.55804 22.6338 3.55204 22.4988L3.50854 21.8193L4.3943 22.3293V22.3301Z",
    fill: "url(#paint25_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_f_1591_14301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M13.3634 15.6792L9.1394 17.9607C9.07972 17.9932 9.02702 18.0371 8.98431 18.09C8.94161 18.1429 8.90974 18.2036 8.89052 18.2688C8.87129 18.334 8.8651 18.4023 8.87229 18.4699C8.87947 18.5375 8.8999 18.603 8.9324 18.6627C8.96491 18.7224 9.00885 18.7751 9.06172 18.8178C9.11458 18.8605 9.17535 18.8923 9.24053 18.9116C9.30572 18.9308 9.37405 18.937 9.44163 18.9298C9.50922 18.9226 9.57472 18.9022 9.6344 18.8697L13.4309 16.7907C13.6156 16.6896 13.8195 16.6286 14.0294 16.6115C14.2392 16.5945 14.4503 16.6218 14.6489 16.6917L21.4717 19.0917V15.4092H14.4322C14.059 15.4092 13.6918 15.502 13.3634 15.6792Z",
    fill: "url(#paint26_linear_1591_14301)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M9.83842 15.166L11.1569 14.3388C11.9379 13.8481 12.8664 13.6472 13.7804 13.771L14.8814 13.921L13.4272 18.9633L13.4197 18.9513C13.3735 18.8731 13.3121 18.8048 13.2393 18.7506C13.1664 18.6963 13.0835 18.6571 12.9953 18.6352C12.9071 18.6134 12.8154 18.6093 12.7257 18.6233C12.6359 18.6372 12.5498 18.6689 12.4724 18.7165L9.82492 20.3463C8.82743 20.9613 7.44817 20.6703 6.82117 19.6788C6.20992 18.712 6.51142 17.3928 7.44967 16.7373L9.83317 15.1758L9.83842 15.166Z",
    fill: "url(#paint27_linear_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M9.83842 15.166L11.1569 14.3388C11.9379 13.8481 12.8664 13.6472 13.7804 13.771L14.8814 13.921L13.4272 18.9633L13.4197 18.9513C13.3735 18.8731 13.3121 18.8048 13.2393 18.7506C13.1664 18.6963 13.0835 18.6571 12.9953 18.6352C12.9071 18.6134 12.8154 18.6093 12.7257 18.6233C12.6359 18.6372 12.5498 18.6689 12.4724 18.7165L9.82492 20.3463C8.82743 20.9613 7.44817 20.6703 6.82117 19.6788C6.20992 18.712 6.51142 17.3928 7.44967 16.7373L9.83317 15.1758L9.83842 15.166Z",
    fill: "url(#paint28_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M9.83842 15.166L11.1569 14.3388C11.9379 13.8481 12.8664 13.6472 13.7804 13.771L14.8814 13.921L13.4272 18.9633L13.4197 18.9513C13.3735 18.8731 13.3121 18.8048 13.2393 18.7506C13.1664 18.6963 13.0835 18.6571 12.9953 18.6352C12.9071 18.6134 12.8154 18.6093 12.7257 18.6233C12.6359 18.6372 12.5498 18.6689 12.4724 18.7165L9.82492 20.3463C8.82743 20.9613 7.44817 20.6703 6.82117 19.6788C6.20992 18.712 6.51142 17.3928 7.44967 16.7373L9.83317 15.1758L9.83842 15.166Z",
    fill: "url(#paint29_radial_1591_14301)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_f_1591_14301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M14.0393 2.0918L16.1753 3.39455",
    stroke: "url(#paint30_linear_1591_14301)",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1591_14301",
    x: 1.2603,
    y: 5.88965,
    width: 11.4665,
    height: 11.8799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.3,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.690196 0 0 0 0 0.372549 0 0 0 0 0.329412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1591_14301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1591_14301",
    x: 4.64258,
    y: 5.00098,
    width: 9.78833,
    height: 14.9531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1591_14301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1591_14301",
    x: 6.50293,
    y: 8.71582,
    width: 15.9092,
    height: 12.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.729412 0 0 0 0 0.462745 0 0 0 0 0.596078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1591_14301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1591_14301",
    x: 6.86938,
    y: 13.4092,
    width: 16.6023,
    height: 7.68262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1591_14301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1591_14301",
    x: 13.6643,
    y: 1.7168,
    width: 2.88599,
    height: 2.05273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_1591_14301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1591_14301",
    x1: 9.17174,
    y1: 7.60436,
    x2: 3.97499,
    y2: 16.5361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9A485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8B7D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8294 7.73344) rotate(151.144) scale(1.81717 1.79453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C28A69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1591_14301",
    x1: 2.77649,
    y1: 12.7719,
    x2: 3.41624,
    y2: 13.1769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9A484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9A484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1591_14301",
    x1: 12.3967,
    y1: 18.4301,
    x2: 17.3205,
    y2: 23.0216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8817C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1591_14301",
    x1: 22.548,
    y1: 22.7028,
    x2: 21.744,
    y2: 22.7028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B7A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0B7A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8765 19.9323) rotate(-25.5699) scale(0.920827 2.15306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A26160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A26160",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5195 19.6803) rotate(121.322) scale(3.44391 4.14961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F5A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B47079"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.26171 19.3773) rotate(90) scale(3.37298 2.96599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#B46D8C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B46D8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1591_14301",
    x1: 6.99971,
    y1: 20.6613,
    x2: 8.34746,
    y2: 20.6613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69983",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.33504 16.3365) rotate(-60.825) scale(13.9007 5.86416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADADAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.33154 16.5232) rotate(-57.9221) scale(3.92779 2.70901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.21461 14.9506) rotate(-60.4538) scale(2.18446 1.43634)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1591_14301",
    x1: 7.57283,
    y1: 17.1877,
    x2: 13.6681,
    y2: 6.50098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929292",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1591_14301",
    x1: 13.4617,
    y1: 10.3196,
    x2: 21.2917,
    y2: 18.2013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A998"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0819 22.9796) rotate(-135.161) scale(7.39476 4.71008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#BC7588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC7588",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6179 13.9076) rotate(149.931) scale(3.88046 1.18025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD0A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1591_14301",
    x1: 18.2812,
    y1: 10.5971,
    x2: 17.5312,
    y2: 12.0498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1C198",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1591_14301",
    x1: 17.8604,
    y1: 10.8078,
    x2: 16.5007,
    y2: 13.6203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEBF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEBF97",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1591_14301",
    x1: 22.7819,
    y1: 16.1051,
    x2: 20.8604,
    y2: 16.1051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEBF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEBF97",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.87928 15.4727) rotate(-45.605) scale(5.48681 6.48305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#C78173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#BA6857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA6857",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1591_14301",
    x1: 11.6543,
    y1: 3.57934,
    x2: 14.6437,
    y2: 5.08984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E999F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CCEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1591_14301",
    x1: 15.672,
    y1: 5.80384,
    x2: 14.9767,
    y2: 5.37034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1591_14301",
    x1: 3.70412,
    y1: 21.1875,
    x2: 4.66112,
    y2: 21.4778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE8C7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1591_14301",
    x1: 5.76737,
    y1: 22.3463,
    x2: 4.69262,
    y2: 21.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E086A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E086A3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1591_14301",
    x1: 4.89812,
    y1: 20.4878,
    x2: 4.76462,
    y2: 20.7045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1591_14301",
    x1: 3.70654,
    y1: 22.2821,
    x2: 4.08005,
    y2: 22.5821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B1A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F0C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1591_14301",
    x1: 11.1412,
    y1: 17.2504,
    x2: 23.4224,
    y2: 17.6517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD3AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1591_14301",
    x1: 7.92292,
    y1: 15.0498,
    x2: 10.0087,
    y2: 17.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD8B63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD8B63",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.50242 19.6908) rotate(-34.4393) scale(3.39835 4.41762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA7A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA7A7B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1591_14301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.02317 21.2373) rotate(-47.2026) scale(1.72485 2.14454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B66F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B66F8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1591_14301",
    x1: 16.0711,
    y1: 3.27305,
    x2: 14.0393,
    y2: 2.16155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F5F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.0ee2628daa1c4d6c968d06ca6b6a95b1.svg";
export { ForwardRef as ReactComponent };